<template>
  <base-button
    v-if="reviewsData?.rollup"
    class="gap-1 items-center i-flex"
    @click="scrollToReviews"
  >
    <vf-rating :value="reviewsData.rollup.averageRating" />
    <span v-if="reviewsData.rollup.reviewCount" aria-hidden="true" class="text-xs">
      ({{ reviewsData.rollup.reviewCount }})
    </span>
    <span class="sr-only">
      <template v-if="reviewsData.rollup.reviewCount">
        {{
          replaceAll(
            $pluralize($t.viewNumberOfReviews, reviewsData.rollup.reviewCount),
            { reviewsCount: reviewsData.rollup.reviewCount },
          )
        }}
      </template>
      <template v-else>
        {{ $t.scrollToReviews }}
      </template>
    </span>
  </base-button>
</template>

<script lang="ts" setup>
import type { ProductReviewsData } from '#types/components/product/reviews'

defineProps<{
  reviewsData?: ProductReviewsData
}>()

const { $gtm } = useNuxtApp()

const scrollToReviews = () => {
  scrollToElement('#reviews', { isCustomSelector: true })
  $gtm.push('pdpPage.onViewReviews')
}
</script>
